import React from "react"
import PropTypes from "prop-types"
import { Box, Tab, Tabs, Tooltip } from "@mui/material"
import { DOWNLOAD_TYPES } from "hooks/budgeting/useDownloadBudgetConfig"
import DownloadBudgetEnum from "common/DownloadBudgetEnum"

const tabsSx = {
  minHeight: 40,
  borderBottom: "1px solid #eee",
  "& .MuiTabs-flexContainer": {
    gap: 0,
  },
  "& .MuiTab-root": {
    textTransform: "none",
    fontSize: 14,
    fontWeight: 500,
    minHeight: 40,
    py: 0,
    px: 1.5,
    color: "#414141",
    "&.Mui-selected": {
      fontWeight: 600,
    },
  },
  "& .MuiTabs-indicator": {
    height: 2,
  },
}

const FilterToggleButtonGroup = ({ tipo, handleChangeTipo, fromTab }) => {
  const items = [
    { label: "Excel", value: DOWNLOAD_TYPES.EXCEL },
    { label: "PDF", value: DOWNLOAD_TYPES.PDF },
    {
      label: "BC3",
      value: DOWNLOAD_TYPES.BC3,
      hidden: fromTab !== DownloadBudgetEnum.DEFAULT,
    },
  ]

  const visibleItems = items.filter(({ hidden }) => !hidden)

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={tipo}
        onChange={handleChangeTipo}
        variant="standard"
        textColor="primary"
        indicatorColor="primary"
        aria-label={visibleItems.map(i => i.label).join(", ")}
        sx={tabsSx}
      >
        {visibleItems.map(({ label, value, disabled }) =>
          disabled ? (
            <Tooltip key={value} title="Próximamente">
              <span>
                <Tab
                  label={label}
                  value={value}
                  disabled
                  data-testid={`download-budget-format-tab-${String(
                    value,
                  ).toLowerCase()}`}
                />
              </span>
            </Tooltip>
          ) : (
            <Tab
              key={value}
              label={label}
              value={value}
              data-testid={`download-budget-format-tab-${String(
                value,
              ).toLowerCase()}`}
            />
          ),
        )}
      </Tabs>
    </Box>
  )
}

FilterToggleButtonGroup.propTypes = {
  tipo: PropTypes.string.isRequired,
  handleChangeTipo: PropTypes.func.isRequired,
  fromTab: PropTypes.number.isRequired,
}

export default FilterToggleButtonGroup
